<template>
  <div class="speed">
    <div class="item" v-for="(item, index) in list" :key="index">
      <div
        :class="[
          { active: index + 1 == nowType },
          { right: index + 1 > nowType },
          { left: index + 1 < nowType },
        ]"
      >
        <div class="num" v-if="index + 1 >= nowType">{{ index + 1 }}</div>
        <img v-else src="../../assets/reset-pass/stepsfinish.png" alt="" />
        <p>{{ item }}</p>
        <div class="heng" v-show="index != list.length - 1"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["nowType", "list"],
  data() {
    return {};
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.speed {
  display: flex;
   font-family: PingFangSC-Regular, PingFang SC;
  .item {
    display: flex;
    align-items: center;
    p {
      margin-left: 8px;
    }
    .left {
      display: flex;
      align-items: center;
      img {
        width: 24px;
        height: 24px;
      }
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #1d2129;
      line-height: 22px;
      p {
        color: #1d2129;
        font-size: 14px;
      }
    }
    .active {
      color: red;
      display: flex;
      align-items: center;
      .num {
        width: 24px;
        height: 24px;
        background: #165dff;
        border-radius: 12px;
        font-size: 14px;
        font-weight: 400;
        color: #ffffff;
        line-height: 24px;
        text-align: center;
      }
      p {
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #165dff;
      }
    }
    .right {
      color: blue;
      display: flex;
      align-items: center;
      .num {
        width: 24px;
        height: 24px;
        background: #f2f3f5;
        border-radius: 12px;
        line-height: 24px;
        text-align: center;
        font-size: 14px;
        font-weight: 400;
        color: #4e5969;
      }
      p {
        color: #4e5969;
        font-size: 14px;
         font-family: PingFangSC-Regular, PingFang SC;
      }
    }
    .heng {
      width: 44px;
      height: 1px;
      background-color: #e5e6eb;
      margin: 0 4px;
    }
  }
}
</style>
